import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import NewsContent from './newsContent';
import WonderfulPic from './wonderfulPic';
import AutoVideo from './autoVideo';
import SelectCar from './selectCar';
import Info from './info';
import SeriesSearch from './seriesSearch';
import HotCars from './hotCars';
import SwiperPic from './swiperPic';
import TxtInfo from './txtInfo';
import TxtInfoFlow from './txtInfoFlow';

import Market from './market';
import RankList from './rankList';
import ViewPoints from './viewPoints';
import { rel } from '../../../../utils/rel';
import Chip from 'Chip';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        return (
            <div className={styles.col}>
                <div className={styles.select_search}>
                    <SeriesSearch />
                    <div className={styles.brand_bg}>
                        <a href="//car.auto.ifeng.com/" target="_blank" rel={rel}>
                            品牌大全
                        </a>
                    </div>
                </div>
                <HotCars ad={content.hotCarAd} />
                {content.curCity ? (
                    <SwiperPic
                        content={content.swiperContent}
                        swiperData={content.swiperData}
                        curCity={content.curCity}
                    />
                ) : (
                    ''
                )}

                {/* 文字链 */}
                <Chip
                    id="225030"
                    type="recommend"
                    title="首页焦点图下方推荐位1-2"
                    groupName="content"
                    content={content.txtInfo}>
                    <TxtInfo ad={content.txtInfoAd}/>  
                </Chip>
                <Chip
                    id="10-586-"
                    type="recommend"
                    title="首页焦点图下方推荐位1-2"
                    groupName="content"
                    content={content.txtInfo2}>
                    <TxtInfoFlow ad2={content.txtInfoAd2}/>            
                </Chip>
                {/* 文字链 */}
                <div className={styles.banner_ad_div}>
                    <Ad className={styles.banner_ad} content={content.banner01Ad} />
                </div>
                {content.curCity ? (
                    <div className={styles.news111} id="module1">
                        <div className={styles.col_L}>
                            <Info content={content.info} curCity={content.curCity} />
                        </div>
                        <NewsContent content={content.rightContent} curCity={content.curCity} />
                    </div>
                ) : (
                    ''
                )}

                <div id="module2">
                    <WonderfulPic />
                </div>
                <div className={styles.banner_ad_div}>
                    <Ad className={styles.banner_ad} content={content.info.banner03Ad} />
                </div>
                <div style={{ overflow: 'hidden' }} id="module3">
                    <AutoVideo content={content.autoVideoList} />
                </div>
                <div className={styles.banner_ad_div}>
                    <Ad className={styles.banner_ad} content={content.info.banner04Ad} />
                </div>
                <div style={{ overflow: 'hidden', marginBottom: '30px' }} id="module4">
                    <SelectCar curCity={content.curCity} />
                </div>
                <div className={styles.banner_ad_div}>
                    <Ad className={styles.banner_ad} content={content.info.banner05Ad} />
                </div>
                <div id="module5" style={{ overflow: 'hidden', marginBottom: '30px' }}>
                    {content.curCity ? <Market curCity={content.curCity} citysData={content.citysData} /> : ''}
                </div>

                <div className={styles.banner_ad_div}>
                    <Ad className={styles.banner_ad} content={content.info.banner06Ad} />
                </div>
                <div id="module6">
                    <ViewPoints content={content.viewPoints} />
                </div>

                <RankList hotArticleRank={content.hotArticleRank} />
            </div>
        );
    }
}

export default Content;
